import RadioGroup from './components/RadioGroup';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'radioGroup',
  pluginComponent: RadioGroup,
});
